<snl-table [useTopScroll]="false" [disableVerticalScroll]="true" class="dynamic-table" *ngIf="offHireOpdays">
  <snl-row>
    <ng-container *ngFor="let item of columnHeader">
      <snl-th [ngStyle]="{'width': item.width}">
        <span>{{item.name}}</span>
      </snl-th>
    </ng-container>
  </snl-row>
  <snl-row *ngFor="let tableItem of tableData; let i = index">
    <snl-td class="text-top">
      {{tableItem.serialNo}}.
    </snl-td>
    <snl-td class="text-top">
      {{tableItem.from | date: 'dd MMM yyyy'}} <br />
      {{tableItem.from | date: 'HH:mm'}} <br />
    </snl-td>
    <snl-td class="text-top">
      {{tableItem.to | date: 'dd MMM yyyy'}} <br />
      {{tableItem.to | date: 'HH:mm'}} <br />
    </snl-td>
    <snl-td class="text-top">
      {{tableItem.days}}
    </snl-td>
    <snl-td class="text-top">
      <div [innerHTML]="tableItem.reason"></div><br><br>
      <span *ngIf="tableItem.isRetroActiveAdjustment;">
        <snl-pills [type]="'outline'" [layout]="'neutral'" class="pills-border"> {{retroactive}}</snl-pills>
      </span>
    </snl-td>
    <snl-td class="text-top">
      <div [innerHTML]="tableItem.remarks"></div>
    </snl-td>
  </snl-row>
</snl-table>

<snl-table [useTopScroll]="false" [disableVerticalScroll]="true" class="dynamic-table" *ngIf="poolPointsTable">
  <snl-row>
    <ng-container *ngFor="let item of columnHeader">
      <snl-th [ngStyle]="{'width': item.width}">
        <span>{{item.name}}</span>
      </snl-th>
    </ng-container>
  </snl-row>
  <snl-row *ngFor="let tableItem of distPoolPointsTableData; let i = index">
    <snl-td class="text-top">
      {{tableItem.serialNo}}.
    </snl-td>
    <snl-td class="text-top">
      <span class="text-inline">{{tableItem.effectiveDate | date: 'dd MMM yyyy'}}</span> <br />
      {{tableItem.effectiveDate | date: 'HH:mm'}} <br />
    </snl-td>
    <snl-td class="text-top">
      <div *ngIf="tableItem.type==='Penalty'">
        <span class="text-inline">{{tableItem.effectiveEndDate | date: 'dd MMM yyyy'}}</span> <br />
        {{tableItem.effectiveEndDate | date: 'HH:mm'}} <br />
      </div>
      <div *ngIf="tableItem.type==='Pool_Point_Updated'">
        <span>N/A</span>
      </div>
    </snl-td>
    <snl-td class="text-top">
      <div *ngIf="tableItem.type==='Penalty'">
        {{tableItem.duration | negativeToBracket}}
      </div>
      <div *ngIf="tableItem.type==='Pool_Point_Updated'">
        <span>N/A</span>
      </div>
    </snl-td>
    <snl-td class="text-top penlty">
      <span class="section-title">{{tableItem.type === 'Pool_Point_Updated' ? 'Pool point update' : tableItem.type}}</span> <br><br>
      <span *ngIf="tableItem?.isRetroactiveAdjustment">
        <snl-pills [type]="'outline'" [layout]="'neutral'" class="pills-border"> {{retroactive}}</snl-pills>
      </span>
    </snl-td>
    <snl-td class="text-top">
      <div class="display-gap" *ngIf="tableItem.type==='Penalty'">
        <p>Penalty amount: {{tableItem.penaltyPercentage}}%</p>
        <div [innerHTML]="tableItem.reason"></div>
      </div>
      <div class="display-gap" *ngIf="tableItem.type==='Pool_Point_Updated'">
        <p>Pool points before {{tableItem.effectiveDate | date: 'dd MMM yyyy'}}: <span class="poolpointDist body-b1">{{tableItem.oldPoolPoint}}</span></p>
        <p>Pool points from {{tableItem.effectiveDate | date: 'dd MMM yyyy'}}: <span class="poolpointDist body-b1">{{tableItem.newPoolPoint}}</span></p>
        <div class="poolPointDistReason" [innerHTML]="tableItem.reason"></div>
      </div>
    </snl-td>
  </snl-row>
</snl-table>

<snl-table [useTopScroll]="false" [disableVerticalScroll]="true" class="dynamic-table" *ngIf="scrubberDays">
  <snl-row>
    <ng-container *ngFor="let item of columnHeader">
      <snl-th [ngStyle]="{'width': item.width}">
        <span>{{item.name}}</span>
      </snl-th>
    </ng-container>
  </snl-row>
  <snl-row *ngFor="let tableItem of scrubberDaysTableData; let i = index">
    <snl-td class="text-top">
      {{tableItem.serialNo}}.
    </snl-td>
    <snl-td class="text-top">
      {{tableItem.delayFrmt | date: 'dd MMM yyyy'}} <br />
      {{tableItem.delayFrmt | date: 'HH:mm'}} <br />
    </snl-td>
    <snl-td class="text-top">
      {{tableItem.delayToGmt | date: 'dd MMM yyyy'}} <br />
      {{tableItem.delayToGmt | date: 'HH:mm'}} <br />
    </snl-td>
    <snl-td class="text-top">
      {{tableItem.duration | negativeToBracket}}
    </snl-td>
    <snl-td class="text-top">
      <div [innerHTML]="tableItem.reason"></div><br><br>
      <span *ngIf="tableItem.isRetroActiveAdjustment;">
        <snl-pills [type]="'outline'" [layout]="'neutral'" class="pills-border"> {{retroactive}}</snl-pills>
      </span>
    </snl-td>    
  </snl-row>
</snl-table>

<snl-table [useTopScroll]="false" [disableVerticalScroll]="true" class="dynamic-table" *ngIf="scrubberPoolPoints">
  <snl-row>
    <ng-container *ngFor="let item of columnHeader">
       <snl-th  [ngStyle]="{'width': item.width}">
        <span>{{item.name}}</span>
      </snl-th>
    </ng-container>   
  </snl-row>
  <snl-row *ngFor="let tableItem of scrubberPoolPointTableData; let i = index">
    <snl-td class="text-top">
      {{tableItem.serialNo}}.
    </snl-td>
    <snl-td class="text-top">
      {{tableItem.effectiveDate | date: 'dd MMM yyyy'}} <br />
      {{tableItem.effectiveDate | date: 'HH:mm'}} <br />
    </snl-td>
    <snl-td class="text-top scrubber-poolpoints-reason">
      <div [innerHTML]="tableItem.reason"></div><br><br>
      <p *ngIf="tableItem.isRetroActiveAdjustment;">
        <snl-pills [type]="'outline'" [layout]="'neutral'" class="pills-border"> {{retroactive}}</snl-pills>
      </p>
    </snl-td>
  </snl-row>
</snl-table>